import HEADER from "../Components/header";
import { useForm, SubmitHandler, useFieldArray } from 'react-hook-form';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import baseUrlApi from '../lib/baseUrlApi';
import { useNavigate, useParams } from 'react-router-dom';
import { containerClasses } from "@mui/material";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import Header from "../Components/header";
import {ApiRequest} from "../Consts/ApiRequest";
import {useCookies} from "react-cookie";

type EnvSettingInputs = {
    siteName: string,
    reloadTime: number,
    mailAddresses: [],
    sitePass: {
        admin: string,
        user: string
    },
    notifyDay: string,
    notifyTime: {
        startHour: string,
        startMinute: string,
        endHour: string,
        endMinute: string,
    }
    emails: { value: string };
};

type FormData = {
    emails: { value: string };
};

type Param = {
    siteId?: string,
    siteRecno?: string,
    controlID?: string
}

const ENVSETTING = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm<EnvSettingInputs>();
    const { register: registerForm, handleSubmit: handleSubmitForm, control, } = useForm({
        defaultValues: {
            emails: [{ email: '' }],
        },
    });
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const params: Param = useParams<Param>();
    const siteId = params.siteId;
    const siteRecno = params.siteRecno;

    const { fields, append, remove } = useFieldArray({
        name: 'emails',
        control,
    });

    const [mailAddresses, setMailAddresses] = useState<string[]>([]);
    const [EnvSettingData, setEnvSettingData] = useState<EnvSettingInputs[]>([]);
    const [siteName, setSiteName] = useState<string>("");
    const [siteNameShow, setSiteNameShow] = useState<string>("");
    const [admin, setAdmin] = useState<string>("");
    const [user, setUser] = useState<string>("");
    const [resErrors, setResErrors] = useState<string[]>([]);

    const [reloadTime, setReloadTime] = useState<number>(0);
    const [startHour, setStartHour] = useState<number>(0);
    const [startMinute, setStartMinute] = useState<number>(0);
    const [endHour, setEndHour] = useState<number>(0);
    const [endMinute, setEndMinute] = useState<number>(0);
    const [monday, setMonday] = useState<number>(0);
    const [tuesday, setTuesday] = useState<number>(0);
    const [wednesday, setWednesday] = useState<number>(0);
    const [thursday, setThursday] = useState<number>(0);
    const [friday, setFriday] = useState<number>(0);
    const [saturday, setSaturday] = useState<number>(0);
    const [sunday, setSunday] = useState<number>(0);

    const handleCheckboxChangeMonday = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setMonday(checked ? 1 : 0);
    };
    const handleCheckboxChangeTuesday = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setTuesday(checked ? 1 : 0);
    };
    const handleCheckboxChangeWednesday = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setWednesday(checked ? 1 : 0);
    };
    const handleCheckboxChangeThursday = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setThursday(checked ? 1 : 0);
    };
    const handleCheckboxChangeFriday = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setFriday(checked ? 1 : 0);
    };
    const handleCheckboxChangeSaturday = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setSaturday(checked ? 1 : 0);
    };
    const handleCheckboxChangeSunday = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setSunday(checked ? 1 : 0);
    };

    const handleSelectChangeStartHours = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        setStartHour(Number(value));
    };

    const handleSelectChangStartMinutes = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        setStartMinute(Number(value));
    };

    const handleSelectChangeEndHours = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        setEndHour(Number(value));
    };

    const handleSelectChangeEndMinutes = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        setEndMinute(Number(value));
    };

    const handleSelectChangeReloadTime = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        setReloadTime(Number(value));
    }

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    // console.log(notifyDay);
    useEffect(() => {

        if(cookies.authority == 4){
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }

        const token = cookies.access_token || "";
        ApiRequest.getSiteSetting({
            siteRecno: siteRecno ?? "",
            siteId: siteId ?? ""
        }, token,
            (response:any)=>{
            setEnvSettingData(response.data);
            setSiteName(response.data.siteName);
            setSiteNameShow(response.data.siteName);
            setAdmin(response.data.sitePass.admin);
            setUser(response.data.sitePass.user);
            setMailAddresses(response.data.mailAddresses);
            remove();
            response.data.mailAddresses.map((email:string, index:number) => {
                append({ email:  email});
            });
            setMonday(Number(response.data.notifyDay.substring(0, 1)));
            setTuesday(Number(response.data.notifyDay.substring(1, 2)));
            setWednesday(Number(response.data.notifyDay.substring(2, 3)));
            setThursday(Number(response.data.notifyDay.substring(3, 4)));
            setFriday(Number(response.data.notifyDay.substring(4, 5)));
            setSaturday(Number(response.data.notifyDay.substring(5, 6)));
            setSunday(Number(response.data.notifyDay.substring(6, 7)));
            setReloadTime(response.data.reloadTime);
            setStartHour(Number(response.data.notifyTime.start.substring(0, 2)));
            setStartMinute(Number(response.data.notifyTime.start.substring(3, 5)));
            setEndHour(Number(response.data.notifyTime.end.substring(0, 2)));
            setEndMinute(Number(response.data.notifyTime.end.substring(3, 5)));
        }, (error: any) => {
            errorCallback(error);
        });
    }, []);

    const onSubmitSearch: SubmitHandler<EnvSettingInputs> = async (data) => {
        try {
            let addresses:string[] = [];
            fields.map((field)=>{
                addresses.push(field.email);
            })
            const token = cookies.access_token || "";
            let params = {
                prcKind: 0,
                siteRecno: siteRecno,
                siteId: siteId,
                mailAddresses: addresses,
                siteName: siteName,
                reloadTime: reloadTime,
                sitePass: {
                    admin: admin,
                    user: user
                },
                notifyDay: "" + monday + tuesday + wednesday + thursday + friday + saturday + sunday,
                notifyTime: {
                    start: String(startHour).padStart(2, '0') + ":" + String(startMinute).padStart(2, '0'),
                    end: String(endHour).padStart(2, '0') + ":" + String(endMinute).padStart(2, '0')
                }
            };
            await ApiRequest.registSiteSetting(params, token, (response: any) => {
                setResErrors(response.data.messsages);
                setEnvSettingData(response.data);
                if (response.data.result === 0) {
                    navigate(-1);
                }
            }, (error: any) => {
                errorCallback(error);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            alert("エラーが発生しました");
        }
    };
    const onSubmitForm = (data: FormData) => {
        const { emails } = data;
        console.log(emails);
    };
    return (
        <div className="wrapper">
            <HEADER
                showMenu={1}
                siteId={siteId}
                siteRecno={siteRecno}
                siteName={siteNameShow}
            />
            <main className="main">
                <section className="page-head" id="page-head">
                    <div className="page-head-block">
                        <div className="page-name">
                            <a onClick={() => navigate(-1)}>
                                <img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" />
                            </a>
                            <div className="page-name-label">環境設定</div>
                        </div>
                        <div className="page-option">
                            <form onSubmit={handleSubmit(onSubmitSearch)}>
                                <button className="btn btn-blue"><i className="icon-check-w"></i>保存</button>
                            </form>
                        </div>
                    </div>
                </section>
                <section className="page-body scroll-block">
                    <div className="box">
                        <div className="edit-box">
                            <div className="edit-box-elm">
                                <form onSubmit={handleSubmit(onSubmitForm)}>
                                    {
                                        resErrors && resErrors.length > 0 ? (
                                            <ul className="error-box">
                                                {resErrors.map((error, index) => (
                                                    error ? (<li key={index}>{error}</li>) : null
                                                ))}
                                            </ul>
                                        ) : null
                                    }
                                    <div className="edit-box-elm-name">メール送信先（最大20件）</div>
                                        {fields.map((mailAddress, index) => (
                                            <div>
                                                <div className="edit-box-elm-input" key={index + ":" + mailAddress.email}>
                                                    <span>{index + 1}</span>
                                                    <input
                                                        type="text"
                                                        defaultValue={mailAddress.email}
                                                        autoComplete={Math.random().toString(32).substring(2) }
                                                        placeholder={`メール${index+1}`}
                                                        {...registerForm(`emails.${index}.email`)}
                                                        className="col-600"
                                                        onChange={(e) => {
                                                            fields[index].email = e.target.value;
                                                        }}
                                                    />
                                                    <a onClick={() => remove(index)}>
                                                        <i className="icon-minus-b"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        ))}
                                    {/* アドレス入力フォーム追加ボタン */}
                                    {fields.length < 20 && (
                                        <a className="edit-add-input" onClick={() => append({ email: '' })}>
                                            <i className="icon-plus-b"></i>
                                            <span>メールアドレスを追加</span>
                                        </a>
                                    )}

                                </form>
                            </div>
                            <div className="edit-box-elm">
                                <div className="edit-box-elm-name">現場名称登録</div>
                                <div className="edit-box-elm-input">
                                    <input
                                        type="text"
                                        value={siteName}
                                        onChange={(e) => setSiteName(e.target.value)}
                                        className="col-100p" />
                                </div>
                            </div>
                            <div className="edit-box-elm">
                                <div className="edit-box-elm-name">データ更新間隔</div>
                                <div className="edit-box-elm-input">
                                    <select
                                        {...register("reloadTime")}
                                        value={reloadTime}
                                        name="reloadTime"
                                        className="col-100p"
                                        onChange={handleSelectChangeReloadTime}
                                    >
                                        <option value="">選択してください</option>
                                        <option value="10">10分</option>
                                        <option value="30">30分</option>
                                        <option value="60">60分</option>
                                    </select>
                                </div>
                            </div>
                            <div className="edit-box-elm">
                                <div className="edit-box-elm-name">管理パスワード</div>
                                <div className="edit-box-elm-input">
                                    <input
                                        type="text"
                                        value={admin}
                                        onChange={(e) => setAdmin(e.target.value)}
                                        className="col-100p"
                                    />
                                </div>
                            </div>
                            <div className="edit-box-elm">
                                <div className="edit-box-elm-name">閲覧パスワード</div>
                                <div className="edit-box-elm-input">
                                    <input
                                        type="text"
                                        value={user}
                                        onChange={(e) => setUser(e.target.value)}
                                        className="col-100p"
                                    />
                                </div>
                            </div>
                            <div className="edit-box-elm">
                                <div className="edit-box-elm-name">メール送信設定</div>
                                <div className="edit-box-elm-subname">曜日</div>
                                <div className="edit-box-elm-input">
                                    <input
                                        type="checkbox"
                                        id="w1"
                                        name="monday"
                                        checked={monday === 1}
                                        onChange={handleCheckboxChangeMonday}
                                    />
                                    <label htmlFor="w1">月</label>
                                    <input
                                        type="checkbox"
                                        id="w2"
                                        name="tuesday"
                                        checked={tuesday === 1}
                                        onChange={handleCheckboxChangeTuesday}
                                    /><label htmlFor="w2">火</label>
                                    <input
                                        type="checkbox"
                                        id="w3"
                                        name="wednesday"
                                        checked={wednesday === 1}
                                        onChange={handleCheckboxChangeWednesday}
                                    /><label htmlFor="w3">水</label>
                                    <input
                                        type="checkbox"
                                        id="w4"
                                        name="thursday"
                                        checked={thursday === 1}
                                        onChange={handleCheckboxChangeThursday}
                                    /><label htmlFor="w4">木</label>
                                    <input
                                        type="checkbox"
                                        id="w5"
                                        name="friday"
                                        checked={friday === 1}
                                        onChange={handleCheckboxChangeFriday}
                                    /><label htmlFor="w5">金</label>
                                    <input
                                        type="checkbox"
                                        id="w6"
                                        name="saturday"
                                        checked={saturday === 1}
                                        onChange={handleCheckboxChangeSaturday}
                                    /><label htmlFor="w6">土</label>
                                    <input
                                        type="checkbox"
                                        id="w7"
                                        name="sunday"
                                        checked={sunday === 1}
                                        onChange={handleCheckboxChangeSunday}
                                    /><label htmlFor="w7">日</label>
                                </div>
                                <div
                                    className="edit-box-elm-subname"
                                >時刻</div>
                                <div className="edit-box-elm-input">
                                    <select
                                        {...register("notifyTime.startHour")}
                                        value={startHour}
                                        name="startHour"
                                        onChange={handleSelectChangeStartHours}
                                    >
                                        {Array.from({ length: 24 }).map((_, i) => (
                                            <option key={i} value={`${i}`}>
                                                {`${String(i).padStart(2, '0')}時`}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        {...register("notifyTime.startMinute")}
                                        value={startMinute}
                                        name="startMinute"
                                        onChange={handleSelectChangStartMinutes}
                                    >
                                        {Array.from({ length: 60 }).map((_, i) => (
                                            <option key={i} value={`${i}`}>
                                                {`${String(i).padStart(2, '0')}分`}
                                            </option>
                                        ))}
                                    </select>
                                    <span>〜</span>
                                    <select
                                        {...register("notifyTime.endHour")}
                                        value={endHour}
                                        name="endHour"
                                        onChange={handleSelectChangeEndHours}
                                    >
                                        {Array.from({ length: 24 }).map((_, i) => (
                                            <option key={i} value={`${i}`}>
                                                {`${String(i).padStart(2, '0')}時`}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        {...register("notifyTime.endMinute")}
                                        value={endMinute}
                                        name="endMinute"
                                        onChange={handleSelectChangeEndMinutes}
                                    >
                                        {Array.from({ length: 60 }).map((_, i) => (
                                            <option key={i} value={`${i}`}>
                                                {`${String(i).padStart(2, '0')}分`}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div >
    );
};
export default ENVSETTING;
